import axios from "axios";
import { getAuthHeaders, getPathAPI, triggerBlobDownload } from "@/helpers";

function capitalizeWord(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

//* the API builds the whole CSV in a single aggregation, honoring the same
//* filters as the recipients table
export async function exportCommunicationRecipients({
  communicationId,
  communicationTitle,
  event,
  read,
  emailOpened,
  engagementLabel,
  email
}: {
  communicationId: string;
  communicationTitle?: string;
  event?: string;
  read?: string;
  emailOpened?: string;
  engagementLabel?: string;
  email?: string;
}): Promise<void> {
  const params: Record<string, string> = {};
  if (event) params.event = event;
  if (read) params.read = read;
  if (emailOpened) params.emailOpened = emailOpened;
  if (email) params.email = email;

  const response = await axios({
    url: `${getPathAPI()}/communications/${communicationId}/recipients/export`,
    method: "GET",
    responseType: "blob",
    params,
    headers: getAuthHeaders()
  });

  const fileNameParts = [
    communicationTitle || "Communication",
    "Recipients",
    event ? capitalizeWord(event) : "",
    engagementLabel || "",
    new Date().toISOString()
  ].filter(Boolean);
  triggerBlobDownload(response.data, `${fileNameParts.join(" - ")}.csv`);
}
